import type { TypeLanguageArgs, TypeLanguageValue } from '../utils/language';
import LanguageManager from '../utils/language/languageManager';
import { detectLocale } from '../utils/language/utils';
import * as exLanguageEnglish from './en';

// ----------------------------------------------------------------------------

class Language {
    #manager: LanguageManager;

    constructor() {
        const supportedLocales = ['en'];
        const defaultLocale = 'en';
        const currentLocale = detectLocale(supportedLocales, defaultLocale);

        this.#manager = new LanguageManager(defaultLocale, currentLocale, supportedLocales, {
            en: { ...exLanguageEnglish },
        });
    }

    get(): LanguageManager {
        return this.#manager;
    }

    set(manager: LanguageManager): void {
        this.#manager = manager;
    }

    setLocale(locale: string): void {
        this.get().setLocale(locale);
    }

    line(str: string, args?: TypeLanguageArgs, locale?: string): string {
        return this.get().line(str, args, locale);
    }

    list(str: string, args?: TypeLanguageArgs, locale?: string): string[] {
        return this.get().list(str, args, locale);
    }

    // The raw value, for a key whose shape is not known up front.
    value(str: string, args?: TypeLanguageArgs, locale?: string): TypeLanguageValue {
        return this.get().getLine(str, args, locale);
    }
}

//
const language = new Language();

// ----------------------------------------------------------------------------

export default language;
